export const FETCH_FE_POD_REQUEST = 'FETCH_FE_POD_REQUEST';
export const FETCH_FE_POD_SUCCESS = 'FETCH_FE_POD_SUCCESS';
export const FETCH_FE_POD_FAILURE = 'FETCH_FE_POD_FAILURE';
